<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">従業員承認申請</h2>

      <TempUserDataTable :user-detail="userDetail" :office="office"/>

      <button class="orange-ellipse_button" @click="accept()">
        承認
      </button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import collection from "@/assets/js/functions/firebase/firestore/collection";
  import TempUserDataTable from "@/components/objects/table/TempUserDataTable";
  import caller from "@/assets/js/functions/firebase/cloud_functions/caller";

  export default {
    name: "ConfirmStaff",

    components: {TempUserDataTable},

    mixins: [collection, caller],

    data() {
      return {
        userDetail: {
          skills: {},
        },
        office: {},
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid'}),
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      this.staffId = location.pathname.replace('/auth/staff/confirm_staff/', '');
      this.staffId = this.staffId.replace(/\/*$/, '');

      await this.getDoc(COLLECTION_NAMES.TEMP_USER_DETAILS, this.staffId).then(async tempUserDetail => {
        this.userDetail = tempUserDetail;
        await this.getDoc(COLLECTION_NAMES.OFFICES, tempUserDetail.office.id).then(async readOffice => {
          this.office = readOffice;
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });

      if (this.office && (this.office.owner.id !== this.uid)) this.$router.push({name: 'Top'});
    },

    methods: {
      async accept() {
        const requestParams = {
          staffId: this.staffId,
          officeId: this.office.id
        };
        await this.callFunction(
          'confirmStaffAccount',
          requestParams
        ).then(() => {
          this.showSuccessMessage('承認メールを送信しました。');
          this.$router.push({name: 'MypageTop'});
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });
      },
    }

  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    > .contents {
      @include form-contents();

      > .user-data_block {
        margin-top: 2rem;
        width: 100%;
      }
    }
  }
</style>